import { createBrowserRouter } from "react-router-dom";
import HomePage from "../HomePage/HomePage";
import Contact from "../Contact/Contact";
import Error404 from "../404/Error404";
import Company from "../Company/Company";
// import News from "../News/News";
import Trainings from "../Trainings/Trainings";
import Training from "../Training/Training";

const browserRouter = createBrowserRouter([
  {
    path: "/",
    element: <HomePage />,
    index: true,
  },
  {
    path: "/entreprise",
    element: <Company />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/formation",
    element: <Trainings type="formation" key="formation" />,
  },
  // {
  //   path: "/supervision",
  //   element: <Trainings type="supervision" key="supervision" />,
  // },
  // {
  //   path: "/service-entreprises",
  //   element: (
  //     <Trainings type="service-entreprises" key="services-entreprises" />
  //   ),
  // },
  {
    path: "/formation/:id",
    element: <Training type="formation" key="formation" />,
  },
  // {
  //   path: "/supervision/:id",
  //   element: <Training type="supervision" key="supervision" />,
  // },
  // {
  //   path: "/service-entreprises/:id",
  //   element: (
  //     <Training type="service-entreprises" key="services-entreprises" />
  //   ),
  // },
  // {
  //   path: "/actualites",
  //   element: <News />,
  // },
  {
    path: "*",
    element: <Error404 />,
  },
]);

export default browserRouter;
